<app-layout [config]="layoutConfig"><router-outlet></router-outlet></app-layout>